import { ChangeDetectionStrategy, Component, effect, input, model, signal, untracked } from '@angular/core';
import { AbstractControl, ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors, Validator } from '@angular/forms';

@Component({
  selector: 'app-date-filter',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <p-fieldset [legend]="label()">
      <div class="grid">
        <div class="col-12 lg:col-6">
          <label class="small-label" for="anno">Anno</label>
          <p-calendar inputId="anno" [selectOtherMonths]="true" view="year" [(ngModel)]="selectedYear" [disabled]="isDisabled()"
            dateFormat="yy" selectionMode="single" [showIcon]="true" [inputStyle]="{'width': '220px'}" [showClear]="true" appendTo="body">
          </p-calendar>
        </div>

        <div class="col-12 lg:col-6">
          <label class="small-label" for="dataDocumento">Intervallo di date</label>
          <p-calendar [(ngModel)]="selectedDateRange" inputId="dataDocumento" [selectOtherMonths]="true" [showClear]="true" [disabled]="!enableDateRange() || isDisabled()"
            dateFormat="dd/mm/yy" selectionMode="range" [showIcon]="true" [inputStyle]="{'width': '420px'}" appendTo="body">
          </p-calendar>
        </div>
      </div>
    </p-fieldset>
  `,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: DateFilterComponent
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: DateFilterComponent
    }
  ]
})
export class DateFilterComponent implements ControlValueAccessor, Validator {

  public label = input<string>('');
  public selectedYear = model<Date | undefined>();
  public selectedDateRange = model<Date[] | undefined>(undefined);
  public enableDateRange = signal<boolean>(true);
  public isDisabled = signal<boolean>(false);

  constructor() {

    effect(() => {
      this.onTouch();
      this.onChange(this.selectedDateRange())
    });

    effect(() => {
      const year = this.selectedYear();

      untracked(() => {
        if (year) {
          const range: Date[] = [new Date(year.getFullYear(), 0, 1), new Date(year.getFullYear(), 11, 31, 23, 59, 59)];
          this.selectedDateRange.set(range);
          this.enableDateRange.set(false);
        } else {
          this.selectedDateRange.set(undefined);
          this.enableDateRange.set(true);
        }
      });
    });
  }

  onChange!: (range: Date[] | undefined) => void;
  onTouch!: () => void;

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  writeValue(range: Date[]): void {
    this.selectedDateRange.set(range);
  }

  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled.set(isDisabled);
  }

  validate(control: AbstractControl<any, any>): ValidationErrors | null {
    const range = this.selectedDateRange();
    return range?.length ? null : { range: true };
  }
}
